import React from "react";
import {
  ArrowRight,
  ArrowUpRight,
  Check,
  MapPin,
  Search,
} from "lucide-react";

import { Link } from "react-router-dom";
import { PageShell } from "../components/Layout";
import { RoomCard } from "../components/Cards";
import { apartmentData } from "../utils/image-data";

import "./Home.css";

export default function Home() {
  const studyApartment = apartmentData.find(
    (apartment) => apartment.id === "study"
  );

  const storyApartment = apartmentData.find(
    (apartment) => apartment.id === "story"
  );

  const silverScreenApartment = apartmentData.find(
    (apartment) => apartment.id === "silver-screen"
  );

  const odeonApartment = apartmentData.find(
    (apartment) => apartment.id === "odeon"
  );

  const discoFlameApartment = apartmentData.find(
    (apartment) => apartment.id === "disco-flame"
  );
  
  return (
    <PageShell>
      <main className="home container">
        <section className="home__hero">
          <div className="home__hero-copy">
            <p className="eyebrow">
              The Bryan Residence · Lekki Phase 1
            </p>

            <h1>
              Luxury stays,
              <br />
              <em>intelligently lived.</em>
            </h1>

            <p>
              Experience luxury, comfort and intelligent living at The Bryan
              Residence — automated holiday apartments designed for
              extraordinary stays.
            </p>

            <div>
              <Link className="home__primary" to="/accommodation">
                Book your stay
                <ArrowRight size={16} />
              </Link>

              <Link className="home__text-link" to="/about">
                The residence
                <ArrowUpRight size={14} />
              </Link>
            </div>

            <span>
              Five luxury automated three-bedroom apartments · Lekki Phase 1,
              Lagos
            </span>
          </div>

          <div
            className="home__hero-image"
            style={{
              backgroundImage: `url(${studyApartment.images[6]})`,
            }}
          >
            <div className="home__search">
              <MapPin size={15} />
              <span>Where would you like to stay?</span>

              <button type="button">
                <Search size={16} />
              </button>
            </div>

            <p>
              Lekki Phase 1
              <br />
              <small>Luxury, close to everything.</small>
            </p>
          </div>
        </section>

        <section className="home__intro-cards">
          <RoomCard
            name={storyApartment.name}
            details={storyApartment.details}
            price={storyApartment.price}
            rating={storyApartment.rating}
            image={storyApartment.images[0]}
          />

          <div>
            <p className="eyebrow">The Bryan Residence standard</p>

            <h2>
              A stay designed
              <br />
              <em>around you.</em>
            </h2>

            <p>
              Elegant apartments, smart comforts and attentive hospitality for
              every kind of visit.
            </p>

            <Link to="/accommodation">
              Explore apartments
              <ArrowRight size={15} />
            </Link>
          </div>

          <RoomCard
            name={silverScreenApartment.name}
            details={silverScreenApartment.details}
            price={silverScreenApartment.price}
            rating={silverScreenApartment.rating}
            image={silverScreenApartment.images[3]}
          />
        </section>

        <section className="home__stays">
          <div className="home__section-head">
            <div>
              <p className="eyebrow">Luxury apartments in Lekki</p>
              <h2>Find your stay.</h2>
            </div>

            <Link to="/accommodation">
              View apartments
              <ArrowUpRight size={16} />
            </Link>
          </div>

          <div className="home__stay-list">
            {[
              studyApartment,
              storyApartment,
              silverScreenApartment,
            ].map((apartment, index) => (
              <article key={apartment.id}>
                <div
                  style={{
                    backgroundImage: `url(${apartment.images[5]})`,
                  }}
                />

                <div>
                  <span>0{index + 1}</span>

                  <h3>{apartment.name}</h3>

                  <p>{apartment.details}</p>
                </div>

                <b>{apartment.price}</b>

                <Link to="/accommodation">
                  <ArrowUpRight size={16} />
                </Link>
              </article>
            ))}
          </div>
        </section>

        <section className="home__promise">
          <div>
            <p className="eyebrow">The Bryan Residence standard</p>

            <h2>
              Luxury, comfort and
              <br />
              <em>intelligent living.</em>
            </h2>

            <p>
              From automated conveniences to personal service, every detail is
              thoughtfully prepared for an exceptional stay.
            </p>

            <Link to="/services">
              Discover our services
              <ArrowRight size={15} />
            </Link>
          </div>

          <div
            className="home__promise-image"
            style={{
              backgroundImage: `url(${odeonApartment.images[0]})`,
            }}
          />

          <div className="home__promise-points">
            {[
              "Five distinct apartment experiences",
              "Pool, gym, restaurant & housekeeping",
              "24-hour electricity, security & Wi-Fi",
            ].map((item, index) => (
              <p key={item}>
                <span>0{index + 1}</span>
                <Check size={15} />
                {item}
              </p>
            ))}
          </div>
        </section>

        <section className="home__metrics">
          {[
            ["5", "luxury apartments"],
            ["3", "bedrooms in every stay"],
            ["24/7", "power, security and support"],
            ["4.95", "guest satisfaction rating"],
          ].map(([number, label]) => (
            <div key={number}>
              <b>{number}</b>
              <span>{label}</span>
            </div>
          ))}
        </section>

        <section
          className="home__deal"
          style={{
            backgroundImage: `url(${discoFlameApartment.images[0]})`,
          }}
        >
          <div className="home__deal-overlay" />

          <div className="home__deal-copy">
            <p className="eyebrow">The Bryan Residence</p>

            <h2>
              Your next stay,
              <br />
              <em>beautifully arranged.</em>
            </h2>

            <p>
              Experience luxury automated living in the heart of Lekki Phase 1,
              with every comfort thoughtfully prepared before you arrive.
            </p>
          </div>

          <article className="home__deal-card">
            <div className="home__deal-card-top">
              <span>Exclusive stay</span>
              <span className="home__deal-rating">★ 4.95</span>
            </div>

            <h3>Book The Bryan Residence</h3>

            <p>
              Three-bedroom luxury apartment
              <br />
              Smart automated living
              <br />
              Lekki Phase 1, Lagos
            </p>

            <div className="home__deal-price">
              <small>Starting from</small>
              <b>₦300,000</b>
              <span>per night</span>
            </div>

            <Link to="/contact">
              Enquire on WhatsApp
              <ArrowRight size={15} />
            </Link>
          </article>
        </section>

        <section className="home__guides">
          <div>
            <p className="eyebrow">Before your stay</p>

            <h2>
              Everything, made
              <br />
              <em>easy.</em>
            </h2>
          </div>

          {[
            "Book your apartment",
            "Special requests",
            "Luxury in Lekki",
          ].map((title, index) => (
            <article key={title}>
              <span>0{index + 1}</span>

              <h3>{title}</h3>

              <p>Everything you need for an exceptional stay.</p>

              <ArrowUpRight size={17} />
            </article>
          ))}
        </section>
      </main>
    </PageShell>
  );
}








// import React from "react";
// import {
//   ArrowRight,
//   ArrowUpRight,
//   Check,
//   MapPin,
//   Search,
// } from "lucide-react";

// import { Link } from "react-router-dom";
// import { PageShell } from "../components/Layout";
// import { RoomCard } from "../components/Cards";
// import { apartmentData } from "../utils/image-data";

// import "./Home.css";

// export default function Home() {
//   const studyApartment = apartmentData.find(
//     (apartment) => apartment.id === "study"
//   );

//   const storyApartment = apartmentData.find(
//     (apartment) => apartment.id === "story"
//   );

//   const silverScreenApartment = apartmentData.find(
//     (apartment) => apartment.id === "silver-screen"
//   );

//   const odeonApartment = apartmentData.find(
//     (apartment) => apartment.id === "odeon"
//   );

//   const discoFlameApartment = apartmentData.find(
//     (apartment) => apartment.id === "disco-flame"
//   );




//   return (
//     <PageShell>
//       <main className="home container">
//         <section className="home__hero">
//           <div className="home__hero-copy">
//             <p className="eyebrow">
//               The Bryan Residence · Lekki Phase 1
//             </p>

//             <h1>
//               Luxury stays,
//               <br />
//               <em>intelligently lived.</em>
//             </h1>

//             <p>
//               Experience luxury, comfort and intelligent living at The Bryan
//               Residence — automated holiday apartments designed for
//               extraordinary stays.
//             </p>

//             <div>
//               <Link className="home__primary" to="/accommodation">
//                 Book your stay
//                 <ArrowRight size={16} />
//               </Link>

//               <Link className="home__text-link" to="/about">
//                 The residence
//                 <ArrowUpRight size={14} />
//               </Link>
//             </div>

//             <span>
//               Five luxury automated three-bedroom apartments · Lekki Phase 1,
//               Lagos
//             </span>
//           </div>

//           <div
//             className="home__hero-image"
//             style={{
//               backgroundImage: `url(${studyApartment.images[6]})`,
//             }}
//           >
//             <div className="home__search">
//               <MapPin size={15} />
//               <span>Where would you like to stay?</span>

//               <button type="button">
//                 <Search size={16} />
//               </button>
//             </div>

//             <p>
//               Lekki Phase 1
//               <br />
//               <small>Luxury, close to everything.</small>
//             </p>
//           </div>
//         </section>

//         <section className="home__intro-cards">
//           <RoomCard
//             name={storyApartment.name}
//             details={storyApartment.details}
//             price={storyApartment.price}
//             rating={storyApartment.rating}
//             image={storyApartment.images[0]}
//           />

//           <div>
//             <p className="eyebrow">The Bryan Residence standard</p>

//             <h2>
//               A stay designed
//               <br />
//               <em>around you.</em>
//             </h2>

//             <p>
//               Elegant apartments, smart comforts and attentive hospitality for
//               every kind of visit.
//             </p>

//             <Link to="/accommodation">
//               Explore apartments
//               <ArrowRight size={15} />
//             </Link>
//           </div>

//           <RoomCard
//             name={silverScreenApartment.name}
//             details={silverScreenApartment.details}
//             price={silverScreenApartment.price}
//             rating={silverScreenApartment.rating}
//             image={silverScreenApartment.images[0]}
//           />
//         </section>

//         <section className="home__stays">
//           <div className="home__section-head">
//             <div>
//               <p className="eyebrow">Luxury apartments in Lekki</p>
//               <h2>Find your stay.</h2>
//             </div>

//             <Link to="/accommodation">
//               View apartments
//               <ArrowUpRight size={16} />
//             </Link>
//           </div>

//           <div className="home__stay-list">
//             {[
//               studyApartment,
//               storyApartment,
//               silverScreenApartment,
//             ].map((apartment, index) => (
//               <article key={apartment.id}>
//                 <div
//                   style={{
//                     backgroundImage: `url(${apartment.images[0]})`,
//                   }}
//                 />

//                 <div>
//                   <span>0{index + 1}</span>

//                   <h3>{apartment.name}</h3>

//                   <p>{apartment.details}</p>
//                 </div>

//                 <b>{apartment.price}</b>

//                 <Link to="/accommodation">
//                   <ArrowUpRight size={16} />
//                 </Link>
//               </article>
//             ))}
//           </div>
//         </section>

//         <section className="home__promise">
//           <div>
//             <p className="eyebrow">The Bryan Residence standard</p>

//             <h2>
//               Luxury, comfort and
//               <br />
//               <em>intelligent living.</em>
//             </h2>

//             <p>
//               From automated conveniences to personal service, every detail is
//               thoughtfully prepared for an exceptional stay.
//             </p>

//             <Link to="/services">
//               Discover our services
//               <ArrowRight size={15} />
//             </Link>
//           </div>

//           <div
//             className="home__promise-image"
//             style={{
//               backgroundImage: `url(${odeonApartment.images[0]})`,
//             }}
//           />

//           <div className="home__promise-points">
//             {[
//               "Five distinct apartment experiences",
//               "Pool, gym, restaurant & housekeeping",
//               "24-hour electricity, security & Wi-Fi",
//             ].map((item, index) => (
//               <p key={item}>
//                 <span>0{index + 1}</span>
//                 <Check size={15} />
//                 {item}
//               </p>
//             ))}
//           </div>
//         </section>

//         <section className="home__metrics">
//           {[
//             ["5", "luxury apartments"],
//             ["3", "bedrooms in every stay"],
//             ["24/7", "power, security and support"],
//             ["4.95", "guest satisfaction rating"],
//           ].map(([number, label]) => (
//             <div key={number}>
//               <b>{number}</b>
//               <span>{label}</span>
//             </div>
//           ))}
//         </section>

//         <section
//           className="home__deal"
//           style={{
//             backgroundImage: `url(${discoFlameApartment.images[0]})`,
//           }}
//         >
//           <div className="home__deal-overlay" />

//           <div className="home__deal-copy">
//             <p className="eyebrow">The Bryan Residence</p>

//             <h2>
//               Your next stay,
//               <br />
//               <em>beautifully arranged.</em>
//             </h2>

//             <p>
//               Experience luxury automated living in the heart of Lekki Phase 1,
//               with every comfort thoughtfully prepared before you arrive.
//             </p>
//           </div>

//           <article className="home__deal-card">
//             <div className="home__deal-card-top">
//               <span>Exclusive stay</span>
//               <span className="home__deal-rating">★ 4.95</span>
//             </div>

//             <h3>Book The Bryan Residence</h3>

//             <p>
//               Three-bedroom luxury apartment
//               <br />
//               Smart automated living
//               <br />
//               Lekki Phase 1, Lagos
//             </p>

//             <div className="home__deal-price">
//               <small>Starting from</small>
//               <b>₦300,000</b>
//               <span>per night</span>
//             </div>

//             <Link to="/contact">
//               Enquire on WhatsApp
//               <ArrowRight size={15} />
//             </Link>
//           </article>
//         </section>

//         <section className="home__guides">
//           <div>
//             <p className="eyebrow">Before your stay</p>

//             <h2>
//               Everything, made
//               <br />
//               <em>easy.</em>
//             </h2>
//           </div>

//           {[
//             "Book your apartment",
//             "Special requests",
//             "Luxury in Lekki",
//           ].map((title, index) => (
//             <article key={title}>
//               <span>0{index + 1}</span>

//               <h3>{title}</h3>

//               <p>Everything you need for an exceptional stay.</p>

//               <ArrowUpRight size={17} />
//             </article>
//           ))}
//         </section>
//       </main>
//     </PageShell>
//   );
// }



